import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SsoModesFetchFailedAction = {
	type: 'SSO_MODES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SsoModesFetchFailedAction => ({
	type: 'SSO_MODES_FETCH_FAILED',
	payload,
});
